import { render, staticRenderFns } from "./ck-content.vue?vue&type=template&id=684179eb&scoped=true&"
import script from "./ck-content.vue?vue&type=script&lang=js&"
export * from "./ck-content.vue?vue&type=script&lang=js&"
import style0 from "./ck-content.vue?vue&type=style&index=0&id=684179eb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684179eb",
  null
  
)

export default component.exports